module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (3).36987159.jpg";